module.exports = __webpack_public_path__ + "static/chip-6115d525bf6e0eca499678538f1740ac.png";